import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category",
    icon: "ri-film-line",
    title: "电影全片库",
    desc: "从《神偷奶爸》到小黄人外传，按年份、类型与评分筛选你想看的每一部。",
    tone: "primary",
    cta: "进入片库",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "上映动态、幕后花絮、周边资讯与行业观察，第一时间掌握最新消息。",
    tone: "accent",
    cta: "查看资讯",
  },
  {
    to: "/reviews",
    icon: "ri-chat-quote-line",
    title: "影评专区",
    desc: "来自影迷与评人的真诚点评，聊聊小黄人为什么总能让人笑出声。",
    tone: "secondary",
    cta: "阅读影评",
  },
];

const toneMap: Record<string, { bubble: string; btn: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    btn: "bg-primary-500 text-foreground-950 hover:bg-primary-400",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-700",
    btn: "bg-accent-500 text-background-50 hover:bg-accent-600",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-700",
    btn: "bg-secondary-500 text-background-50 hover:bg-secondary-600",
  },
};

export default function QuickEntries() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {entries.map((entry) => {
          const tone = toneMap[entry.tone];
          return (
            <Link
              key={entry.to}
              to={entry.to}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${tone.bubble}`}>
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{entry.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {entry.desc}
              </p>
              <span
                className={`mt-5 inline-flex w-fit items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition ${tone.btn}`}
              >
                {entry.cta}
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}